<app-page-header></app-page-header>

<app-unauthenticated-menu></app-unauthenticated-menu>

<section class="vh-90" style="background-color: #b0cafa;">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-2-strong" style="border-radius: 1rem;">
          <div class="card-body p-5 text-center">

            <h3 class="mb-5">
              {{ 'Main.ForgotPassword.ForgotPassword' | translate }}
            </h3>

            <div class="form-outline mb-4">
              <label class="form-label" for="typeEmailX-2">
                {{ 'Main.ForgotPassword.EnterEmail' | translate }}
              </label>
              <input type="email" id="typeEmailX-2" class="form-control form-control-lg" [(ngModel)]="userName"/>
            </div>

            <div class="form-outline mb-4">
              <button class="btn btn-primary btn-lg btn-block" (click)="ResetPassword()"
                *ngIf="!requestSent" [disabled]="userName ==='' || loading">
                {{ 'Main.ForgotPassword.ResetPassword' | translate }}
              </button>
              <button *ngIf="loading" class="btn ms-3" disabled>
                <span class="spinner-border spinner-grow-sm"></span>
                {{ 'Main.Loading' | translate }}
              </button>
            </div>

            <div class="form-outline mb-4" *ngIf="requestSent">
              <label class="form-label" for="typeEmailX-2">
                {{ 'Main.ForgotPassword.CheckEmail' | translate }}
              </label>
              <button class="btn btn-primary btn-lg btn-block" (click)="BackToLogin()">
                {{ 'Main.ForgotPassword.BackToLogin' | translate }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>